import CostCodes from './CostCodes.component';
import { ManageCostCodesModal } from './ManageCostCodesModal.component';

export default {
	CostCodes,
	ManageCostCodesModal,
};
